import DeviceCmClient from './DeviceCmClient';
import HolderCmClient from './HolderCmClient';

const getCmClient = (isHolder) => (id, options) => {
    try {
        const Client = isHolder ? HolderCmClient : DeviceCmClient;

        return new Client(id, options);
    } catch (e) {
        return null;
    }
};

/*const waitUntilConnected = async (params) => {
    const {isHolder, isCheckDeviceReady = false} = params || {};
    let {timer = cmTimeouts.CM_CONNECT_TIMEOUT * 10} = params || {};

    const isConnected = selectIsConnectedToCm(isHolder);

    if (isConnected) return true;

    const cmClient = getCmClient(isHolder)();

    if (!cmClient) return false;

    if (--timer < 0) {
        if (isCheckDeviceReady) {
            log.error(
                `CM Client. CONNECTED status does not arrive from uam websocket or device is not ready. isHolder: ${isHolder}`
            );
        } else {
            log.error(`CM Client. CONNECTED status does not arrive from uam websocket. isHolder: ${isHolder}`);
        }
        return false;
    }

    await helpers.timeout(100);
    return await waitUntilConnected({isHolder, timer, isCheckDeviceReady});
};*/

export default {
    getCmClient,
    //waitUntilConnected,
};
